import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-cr-back-button',
  templateUrl: './cr-back-button.component.html',
  styleUrls: ['./cr-back-button.component.scss'],
})
export class CrBackButtonComponent implements OnInit {
  @Input() routerLink: any[] = [];
  @Input() goBack = false;

  @Input() icon?: string = 'chevron_left';
  @Input() tooltipText?: string;
  @Input() fontSize?: 'LARGE' | 'MEDIUM' | 'SMALL' = 'MEDIUM';

  public cssClasses: string[] = [];

  constructor(private readonly location: Location) {}

  public ngOnInit() {
    this.cssClasses = [`FONT-${this.fontSize}`];
  }

  public onClick() {
    if (this.goBack) {
      this.location.back();
      return;
    }

    if (!this.goBack) {
      return;
    }
  }
}
